import { render, staticRenderFns } from "./NavbarAuthDialog.vue?vue&type=template&id=4256a5b6"
import script from "./NavbarAuthDialog.vue?vue&type=script&lang=js"
export * from "./NavbarAuthDialog.vue?vue&type=script&lang=js"
import style0 from "./NavbarAuthDialog.vue?vue&type=style&index=0&id=4256a5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports